import React, { useState, useEffect } from 'react';
import io from 'socket.io-client';
import axios from 'axios';
import { onMessageListener } from '../config/firebase';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

const socket = io('http://localhost:5500');

const Dashboard = () => {
    const [notifications, setNotifications] = useState([]);
    const userId = localStorage.getItem('user_id'); // Get authenticated user ID
    const username = localStorage.getItem('username');

    console.log('Your user id: ', userId);

    useEffect(() => {
        if (!userId) return;

        // Fetch past notifications
        // axios.get(`http://localhost:5000/api/notifications/notifications?user_id=${userId}`)
        //     .then(response => {
        //         if (Array.isArray(response.data.notifications)) {
        //             setNotifications(response.data.notifications);
        //         } else {
        //             console.error('Invalid response format:', response.data);
        //             setNotifications([]); // Ensure notifications is always an array
        //         }
        //     })
        //     .catch(error => {
        //         console.error('Error fetching notifications:', error);
        //         setNotifications([]); // Reset state on error
        //     });

        // // Listen for new notifications only for the logged-in user
        // socket.on(`new-notification-${userId}`, (notification) => {
        //     setNotifications(prev => Array.isArray(prev) ? [...prev, notification] : [notification]);
        //     toast.info(`${notification.title}: ${notification.body}`);
        // });

        // return () => socket.off(`new-notification-${userId}`);
    }, [userId]);

    return (
        <div>
            <h1>Dashboard - Received Notifications</h1>
            <h3>Welcome, {username}</h3>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar />
            {notifications.length > 0 ? (
                <ul>
                    {notifications.map((notification, index) => (
                        <li key={index}>
                            <strong>{notification.title}</strong>
                            <p>{notification.body}</p>
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No notifications received yet.</p>
            )}
        </div>
    );
};

export default Dashboard;